import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import CrossIcon from '../../../../commonComponents/icons/CrossIcon';

const FastBonusCard = props => {
  const { t, index, bonusData } = props;

  const {
    bonusType,
    numDays,
    commission,
    daysRemaining,
    skillLevelName,
    objectiveLevel,
    bonusAchieved,
    currencyInfo,
  } = bonusData;

  const renderIcon = () => {
    switch (bonusAchieved) {
      case true:
        return <CheckIcon color="#3FBC5F" />;
      case false:
        return <CrossIcon color="#3FBC5F" />;
      case null:
      default:
        return null;
    }
  };

  const commissionValue = newFormatPrice(commission, true, currencyInfo.code);

  return (
    <div className="card fast-bonus-card">
      <div className="fast-bonus-card-header">
        <span>{t(`report.neofin.fastBonus.${bonusType}`)}</span>
        <div className="completedStageCheck">{renderIcon()}</div>
      </div>
      {daysRemaining && daysRemaining !== 0 ? (
        <div className="fast-bonus-days-remaining">{`${daysRemaining} / ${numDays} ${t(
          'report.neofin.fastBonus.daysRemaining',
        )}`}</div>
      ) : (
        <></>
      )}
      <div className="fast-bonus-card-body">
        {t(
          'report.neofin.fastBonus.description',
          numDays,
          objectiveLevel,
          skillLevelName,
          commissionValue,
        )}
      </div>
    </div>
  );
};

FastBonusCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  bonusData: PropTypes.shape({
    bonusType: PropTypes.string,
    numDays: PropTypes.number,
    daysRemaining: PropTypes.number,
    skillLevelName: PropTypes.string,
    objectiveLevel: PropTypes.number,
    commission: PropTypes.number,
    bonusAchieved: PropTypes.bool,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
  }).isRequired,
};

export default translate(FastBonusCard);
